<div class="dds__container middle-container" style="min-height: 27.75rem;margin-top: 10px;">
  <div *ngIf="loading || attachmentLoading" class="dds__modal dds__loading-modal dds__d-block" tabindex="-1"
    role="dialog">
    <div class="dds__modal-dialog" role="document">
      <div class="dds__modal-content">
        <div class="dds__modal-body dds__text-center">
          <div class="dds__mb-3" id="modalId">
            <div class="dds__progress-bar">
              <div class="dds__progress-bar-standard dds__progress-bar-striped dds__progress-bar-animated"
                role="progressbar" data-showtext="true"></div>
            </div>
          </div>
          <p>Processing... Please wait.</p>
        </div>
      </div>
    </div>
  </div>


  <div *ngIf="!loading && (RoleName==Moderator || RoleName==Publisher)" style="margin-bottom:10px;">
    <div [ngClass]="statusMap.get(article.Status)" class="dds__label-badge" style="text-transform: uppercase;">
      {{article.Status}} </div>
    <div *ngIf="secondaryStatus" [ngClass]="statusMap.get(secondaryStatus)" class="dds__label-badge"
      style="text-transform: uppercase;">
      {{secondaryStatus}} </div>
    <div [ngClass]="accesslevelMap.get(article.Accesslevel)" class="dds__label-badge"
      style="  text-transform: uppercase;">{{article.Accesslevel}} </div>

  </div>
  <button class='dds__btn dds__btn-secondary dds__float-right' (click)="btnBack(article.Status)">Back </button>

  <a *ngIf="!loading && (RoleName==Moderator && article.Status==Deleted)" class="iconSet dds__pr-2" color="primary"
    style="text-transform: uppercase;cursor:pointer;" (click)="openDialogForRestore(Deleted,'')">

    <svg class="dds__svg-icons customToolbarSvg" aria-hidden="true" style=" width: 21px;height:13px;color: #0076CE;">
      <use xlink:href="#dds__reset" />
    </svg>Restore
  </a>
  <a *ngIf="!loading && ((RoleName == Moderator && (article.Status!=Deleted && article.Status!=Published)) || (RoleName == Publisher && article.Status == Drafted || article.Status == Rejected)) "
    class="iconSet dds__pr-2" color="primary" [routerLink]="[editUrl,article.Id]">
    <svg class="dds__svg-icons " aria-hidden="true" style=" width: 18px;height:20px;color: #0076CE;">
      <use xlink:href="#dds__pencil" />
    </svg> EDIT</a>

  <div class="dds__col-10" *ngIf="!loading" class="dds__h1" style="text-align: center;max-width: 85.9999%;">{{article.Title}}</div>


  <!-- Using hidden because accordian wont work if removed from DOM -->
  <div [hidden]="loading" id="independent-accordion-showhide" class="dds__accordion dds__mb-3">
    <div class="dds__show-hide-container"> <button (click)="renderAttachment()" id="indpt-show-all-btn"
        class="dds__btn-link dds__show-all" aria-expanded="false"> <span>Show All</span> </button> | <button
        id="indpt-hide-all-btn" class="dds__btn-link dds__hide-all" aria-expanded="false"> <span>Hide All</span>
      </button> </div>



    <div class="dds__accordion-card">
      <div class="dds__accordion-card-header">
        <h5 class="dds__mb-0"> <button id="panelOneNestedButton" class="dds__accordion-btn dds__d-flex" type="button"
            data-toggle="dds__collapse" data-target="#panelOneNested" aria-expanded="true"
            aria-controls="panelOneNested">
            <svg class="dds__icons dds__chevron-right dds__svg-icons custom-svg" aria-hidden="true">
              <use xlink:href="#dds__chevron-right" />
            </svg>
            <span id="headline1" class="dds__mx-2">Article Description </span> </button> </h5>
      </div>
      <div id="panelOneNested" role="region" class="dds__collapse dds__show" aria-labelledby="headline1"
        aria-expanded="true">
        <div class="dds__accordion-card-body">
          <div *ngIf="!loading" class="displayContent ql-editor" style="padding: 0px !important;"
            [innerHTML]="article.Content | safeHtml"></div>
        </div>
        <!-- Tags -->
        <!-- <div class="dds__accordion-card-body">
          <div class="dds__secondary-accordion">
            <h5 class="dds__mb-0"> <button aria-label="Show / Hide content for Secondary Accordion"
                class="dds__secondary-accordion-btn dds__d-flex " type="button" data-toggle="dds__collapse"
                data-target="#secondaryAccordionOne" aria-expanded="true" aria-controls="secondaryAccordionOne"
                role="button"> <i class="dds__icons dds__arrow-tri-solid-right" aria-hidden="true"></i>
                <span class="dds__mx-2">Tags</span> </button> </h5>
            <div id="secondaryAccordionOne" class="dds__collapse dds__show" aria-expanded="true" role="region">
              <div *ngIf="!loading" class="dds__secondary-accordion-body dds__mb-2">
                <div *ngFor="let i of article.tags"
                  class="dds__btn dds__btn-secondary dds__btn-sm dds__filter-btn-clear tag ">{{i}}</div>

              </div>
            </div>
          </div>
        </div> -->
      </div>
    </div>


    <div [hidden]="!(!loading && article && article.AttachmentId)" class="dds__accordion-card">
      <div class="dds__accordion-card-header">
        <h5 class="dds__mb-0">
          <button (click)="renderAttachment()" id="panelTwoButton" class="dds__accordion-btn dds__collapsed dds__d-flex"
            type="button" data-toggle="dds__collapse" data-target="#panelTwo" aria-expanded="true"
            aria-controls="panelTwo" role="button">
            <svg class="dds__icons dds__chevron-right dds__svg-icons custom-svg" aria-hidden="true">
              <use xlink:href="#dds__chevron-right" />
            </svg>
            <span id="headline" class="dds__mx-2">Uploaded
              Attachment
            </span> </button>
        </h5>
      </div>

      <div [hidden]="!(!loading && article &&  article.AttachmentUrl)" id="panelTwo" role="region" class="dds__collapse"
        aria-labelledby="headline" aria-expanded="true">
        <div class="dds__accordion-card-body">
          <div class="article-doc">
            <iframe *ngIf="!loading" [src]="AttachmentURL | safe" alt="article.Title" frameborder="0"></iframe>
          </div>
        </div>
      </div>
    </div>


    <br><br><br>
    <div *ngIf="!loading && (RoleName==Moderator || RoleName==Publisher)">
      <div>
        <svg class="dds__svg-icons custom" aria-hidden="true" style=" width: 18px;height:20px;color: #0076CE;">
          <use xlink:href="#dds__user" />
        </svg>
        <span style="color: #0076CE;">Published By: </span>
        <span>{{article.PublisherName}}</span>
      </div>
      <div>
        <svg class="dds__svg-icons custom" aria-hidden="true" style=" width: 18px;height:20px;color: #0076CE;">
          <use xlink:href="#dds__calendar" />
        </svg>
        <span style="color: #0076CE;">Schedule Date: </span>
        <span>{{article.ScheduledStartDate | date: 'MM/dd/yyyy' }}</span>
        <span *ngIf="article.ScheduledEndDate"> - {{article.ScheduledEndDate | date: 'MM/dd/yyyy'}}</span>
      </div>
      <div>
        <svg class="dds__svg-icons custom" aria-hidden="true" style=" width: 18px;height:20px;color: #0076CE;">
          <use xlink:href="#dds__eye-view-on" />
        </svg>
        <span style="color: #0076CE;">Access Level: </span>
        <span>{{article.Accesslevel}}</span>
      </div>
      <div>
        <svg class="dds__svg-icons custom" aria-hidden="true" style=" width: 18px;height:20px;color: #0076CE;">
          <use xlink:href="#dds__alert-info-cir" />
        </svg>
        <span style="color: #0076CE;">Status: </span>
        <span>{{article.Status}}</span>
      </div>
      <div *ngIf="article && article.Comments && (article.Status===Rejected || article.Status===Published)">
        <svg class="dds__svg-icons custom" aria-hidden="true" style=" width: 18px;height:20px;color: #0076CE;">
          <use xlink:href="#dds__comment" />
        </svg>
        <span style="color: #0076CE;">Comments: </span>
        <span>{{article.Comments}}</span>
      </div>
    </div>
  </div>


  <div *ngIf="!loading && RoleName==Moderator && article.Status=='Pending Approval'">
  <div style="color: #ce1126;" *ngIf="endDateError">*{{endDateError}}</div>
  <br>
    <button [disabled]="endDateError" class="dds__btn dds__btn-purchase dds__form-check-inline " type="submit" name="approve" value="approve"
      (click)="openDialog(Published)">Approve </button>
    <button class="dds__btn dds__form-check-inline dds__btn-secondary" type="submit" name="reject" value="reject"
      (click)="openDialog(Rejected)">Reject </button>
  </div>
</div>
